/* eslint-disable */
export default {
  order: 3,
  header: [
    {
      category: 'Overview',
      item: [
        {
          title: '',
          list: [
            {
              name: 'What is EnOS',
              url: '/docs/enos/en/2.4.4/overview/enos_introduction.html'
            },
            {
              name: 'EnOS Advantages',
              url: '/docs/enos/en/2.4.4/overview/advantage.html'
            },
            {
              name: 'Key Concepts',
              url: '/docs/enos/en/2.4.4/overview/concepts.html'
            }
          ]
        }
      ],
      layout: 'vertical',
      showListInMobile: true
    },
    {
      category: 'Product Documentation',
      item: [
        {
          title: 'Application Building',
          list: [
            {
              name: 'Application Portal',
              url: '/docs/app-portal/en/2.4.4/overview.html'
            },
            {
              name: 'EnOS Mobile',
              url: '/docs/maf/en/2.4.4/intro/overview.html'
            },
            {
              name: 'Digital Twin Visualization',
              url: '/docs/dtv/en/2.4.4/overview.html'
            },
            {
              name: 'Unified Monitoring',
              url: '/docs/monitor/en/2.4.4/overview/monitor_overview.html'
            },
            {
              name: 'Reporting Tool',
              url: '/docs/reporting/en/2.4.4/overview.html'
            },
            {
              name: 'Work Management',
              url: '/docs/wmt/en/2.4.4/about.html'
            },
            {
              name: 'Fleet Control',
              url: '/docs/control/en/2.4.4/overview.html'
            },
            {
              name: 'Metric Management',
              url: '/docs/metric-management/en/2.4.4/overview/metrics_overview.html'
            }
          ]
        },
        {
          title: 'Data Management',
          list: [
            {
              name: 'Time Series Data Management',
              url: '/docs/time-series-data/en/2.4.4/overview.html'
            },
            {
              name: 'Common Data Service',
              url: '/docs/cds/en/2.4.4/overview.html'
            },
            {
              name: 'Data Subscription',
              url: '/docs/data-subscription/en/2.4.4/data_subscription_overview.html'
            },
            {
              name: 'Data Archiving',
              url: '/docs/data-archiving/en/2.4.4/archive_policy.html'
            },
            {
              name: 'Data Source Registration',
              url: '/docs/data-source-reg/en/2.4.4/datasource_overview.html'
            }
          ]
        },
        {
          title: 'Device Connection',
          list: [
            {
              name: 'Device Connection',
              url: '/docs/device-connection/en/2.4.4/learn/message_flow.html'
            },
            {
              name: 'Device Management',
              url: '/docs/device-connection/en/2.4.4/learn/device_lifecycle_management.html'
            },
            {
              name: 'Device Data Integration Service',
              url: '/docs/device-integration/en/2.4.4/learn/device_integration_overview.html'
            },
            {
              name: 'Alarm Management',
              url: '/docs/alarm-management/en/2.4.4/overview/about.html'
            },
            {
              name: 'Alert Engine',
              url: '/docs/alert/en/2.4.4/learn/alert_overview.html'
            },
            {
              name: 'Data Quality',
              url: '/docs/data-quality/en/2.4.4/overview/about.html'
            },
            {
              name: 'Device Provisioning Service',
              url: '/docs/device-provisioning/en/2.4.4/overview/about.html'
            },
            {
              name: 'Device Management as a Service',
              url: '/docs/dmaas/en/2.4.4/about.html'
            },
            {
              name: 'EnOS Edge',
              url: '/docs/enos-edge/en/2.4.4/edge_overview.html'
            }
          ]
        }
      ],
      layout: 'vertical',
      footer: {
        name: 'View all products',
        image: 'assets/images/header/document_center.svg',
        url: '/docs/en/2.4.4'
      },
      showListInMobile: false
    },
    {
      category: 'Tutorials',
      item: [
        {
          title: 'Data Integration',
          list: [
            {
              name: 'Connecting a Simulated Device to EnOS Cloud',
              url: '/docs/device-connection/en/2.4.4/tutorial/connecting_device_simulated/index.html'
            },
            {
              name: 'Connecting a Simulated Electricity Meter to EnOS Edge',
              url: '/docs/enos-edge/en/2.4.4/tutorial/connecting_edge.html'
            },
            {
              name: 'Integrating PC Device Data',
              url: '/docs/device-integration/en/2.4.4/howto/tutorial_pc_device_mgmt.html'
            }
          ]
        },
        {
          title: 'Data Development',
          list: [
            {
              name: 'Assessing Data Quality of the Wind Turbine',
              url: '/docs/data-quality/en/2.4.4/tutorial.html'
            },
            {
              name: 'Developing Metrics of Solar Generation, Temperature, and Radiance',
              url: '/docs/metric-management/en/2.4.4/tutorial/index.html'
            },
            {
              name: 'Customizing Production(SPLM) Metric for Solar Sites',
              url: '/docs/cds/en/2.4.4/tutorial/tutorial_solar.html'
            }
          ]
        },
        {
          title: 'Application Development',
          list: [
            {
              name: 'Creating Applications Using Common Building Blocks',
              url: '/docs/app-development/en/2.4.4/app_dev_workflow/index.html'
            },
            {
              name: 'Building a Smart Battery Dashboard',
              url: '/docs/dtv/en/2.4.4/tutorial/index.html'
            },
            {
              name: 'Building a Water Purification System Monitoring Page',
              url: '/docs/dtv/en/2.4.4/tutorial/monitor.html'
            }
          ]
        }
      ],
      layout: 'horizontal',
      footer: {
        name: 'View all tutorials',
        image: 'assets/images/header/tutorial_center.svg',
        url: '/docs/en/2.4.4/tutorial'
      },
      showListInMobile: false
    },
    {
      category: 'Resources',
      item: [
        {
          title: '',
          list: [
            {
              name: 'EnOS APIs',
              url: 'https://developer.enos-iot.com/enos-apis/'
            },
            {
              name: 'SDKs and Tools',
              url: 'https://developer.enos-iot.com/enos-sdks-tools/'
            }
          ]
        }
      ],
      layout: 'vertical',
      showListInMobile: true
    }
  ],
  content: {
    Cards: [
      {
        name: 'EnOS 101',
        description: 'Learn about the advantages and key concepts of EnOS.',
        image: 'assets/images/landing/cards/started_information.svg',
        url: '/docs/enos/en/2.4.4/overview/enos_introduction.html'
      },
      {
        name: 'Tutorials',
        description: 'Explore step-by-step walkthroughs of core scenarios to quickly get started with EnOS.',
        image: 'assets/images/landing/cards/tutorial.svg',
        url: '/docs/en/2.4.4/tutorial'
      },
      {
        name: 'Release Management Guide',
        description: 'Learn about EnOS Cloud versioning mechanism and how to access version-specific documentation.',
        image: 'assets/images/landing/cards/version_guide.svg',
        url: '/docs/enos/en/2.4.4/release_management'
      },
      {
        name: 'Release Notes',
        description: 'Check out EnOS release notes.',
        image: 'assets/images/landing/cards/version_description.svg',
        url: '/docs/enos/en/2.4.4/releasenotes/index.html'
      },
      {
        name: 'EnOS APIs',
        description: 'Leverage Open APIs to access EnOS resources and develop diverse applications easily.',
        image: 'assets/images/landing/cards/api_reference.svg',
        url: '/docs/api/en/2.4.4/overview.html'
      },
      {
        name: 'SDKs and Tools',
        description: 'Obtain EnOS SDKs and tools and develop applications based on EnOS.',
        image: 'assets/images/landing/cards/sdk_tools.svg',
        url: 'https://developer.enos-iot.com/enos-sdks-tools/'
      }
    ],
    Products: [
      {
        category: 'Application Building',
        item: [
          {
            name: 'Application Portal',
            image: 'assets/images/landing/products/application_portal.svg',
            url: '/docs/app-portal/en/2.4.4/overview.html'
          },
          {
            name: 'EnOS Mobile',
            image: 'assets/images/landing/products/enos_mobile.svg',
            url: '/docs/maf/en/2.4.4/intro/overview.html'
          },
          {
            name: 'Digital Twin Visualization',
            image: 'assets/images/landing/products/digital_twin_visualization.svg',
            url: '/docs/dtv/en/2.4.4/overview.html'
          },
          {
            name: 'Unified Monitoring',
            image: 'assets/images/landing/products/unified_monitoring.svg',
            url: '/docs/monitor/en/2.4.4/overview/monitor_overview.html'
          },
          {
            name: 'Reporting Tool',
            image: 'assets/images/landing/products/reporting_tool.svg',
            url: '/docs/reporting/en/2.4.4/overview.html'
          },
          {
            name: 'Work Management',
            image: 'assets/images/landing/products/work_management.svg',
            url: '/docs/wmt/en/2.4.4/about.html'
          },
          {
            name: 'Fleet Control',
            image: 'assets/images/landing/products/fleet_control.svg',
            url: '/docs/control/en/2.4.4/overview.html'
          },
          {
            name: 'Metric Management',
            image: 'assets/images/landing/products/metric_management.svg',
            url: '/docs/metric-management/en/2.4.4/overview/metrics_overview.html'
          }
        ]
      },
      {
        category: 'Data Management',
        item: [
          {
            name: 'Time Series Data Management',
            image: 'assets/images/landing/products/time_series_data_management.svg',
            url: '/docs/time-series-data/en/2.4.4/overview.html'
          },
          {
            name: 'Common Data Service',
            image: 'assets/images/landing/products/common_data_service.svg',
            url: '/docs/cds/en/2.4.4/overview.html'
          },
          {
            name: 'Data Subscription',
            image: 'assets/images/landing/products/data_subscription.svg',
            url: '/docs/data-subscription/en/2.4.4/data_subscription_overview.html'
          },
          {
            name: 'Data Archiving',
            image: 'assets/images/landing/products/data_source_registration.svg',
            url: '/docs/data-archiving/en/2.4.4/archive_policy.html'
          },
          {
            name: 'Data Source Registration',
            image: 'assets/images/landing/products/data_source_registration 2.svg',
            url: '/docs/data-source-reg-app/en/2.4.4/datasource_overview.html'
          }
        ]
      },
      {
        category: 'Device Connection',
        item: [
          {
            name: 'Device Connection',
            image: 'assets/images/landing/products/device_connectivity.svg',
            url: '/docs/device-connection/en/2.4.4/learn/message_flow.html'
          },
          {
            name: 'Device Management',
            image: 'assets/images/landing/products/device_management.svg',
            url: '/docs/device-connection/en/2.4.4/learn/device_lifecycle_management.html'
          },
          {
            name: 'Device Data Integration Service',
            image: 'assets/images/landing/products/device_data_integration_service.svg',
            url: '/docs/device-integration/en/2.4.4/learn/device_integration_overview.html'
          },
          {
            name: 'Alarm Management',
            image: 'assets/images/landing/products/alert_management.svg',
            url: '/docs/alarm-management/en/2.4.4/overview/about.html'
          },
          {
            name: 'Alert Engine',
            image: 'assets/images/landing/products/alert_management.svg',
            url: '/docs/alert/en/2.4.4/learn/alert_overview.html'
          },
          {
            name: 'Data Quality',
            image: 'assets/images/landing/products/data_quality.svg',
            url: '/docs/data-quality/en/2.4.4/overview/about.html'
          },
          {
            name: 'Device Provisioning Service',
            image: 'assets/images/landing/products/alert_management.svg',
            url: '/docs/device-provisioning/en/2.4.4/overview/about.html'
          },
          {
            name: 'Device Management as a Service',
            image: 'assets/images/landing/products/device_management.svg',
            url: '/docs/dmaas/en/2.4.4/about.html'
          },
          {
            name: 'EnOS Edge',
            image: 'assets/images/landing/products/device_provisioning_service.svg',
            url: '/docs/enos-edge/en/2.4.4/edge_overview.html'
          }
        ]
      }
    ]
  }
};
